export * from './hapiness.client.options.interface';
